import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import NumberInput from '../../../../../../../../../../../../../../components/forms/number-input/NumberInput';
import { EMISSION_MAX_FRACTION_DIGIT } from '../../../../../../../../../../../../../../shared/constants/products.constant';
import WasteTreatmentDropDown from '../../../injection-molding-form/components/waste-treatment-dropdown/WasteTreatmentDropdown';

interface InputMaterialFieldsFormProps {
  /** Path of the material this card edits, e.g. `processes[0].input_materials[2]`. */
  formPath: string;
  processIndex: number;
}

const InputMaterialFieldsForm = ({ formPath, processIndex }: InputMaterialFieldsFormProps) => {
  const {
    control,
    formState: { submitCount },
    trigger,
  } = useFormContext();

  const { t } = useTranslation();

  const wastePerPiece = useWatch({ name: `${formPath}.waste_per_piece`, control });

  // Waste treatment is only required once this material wastes something, and the
  // waste/scrap value is also compared against the amount.
  useEffect(() => {
    if (submitCount > 0) {
      trigger([`${formPath}.waste_treatment`, `${formPath}.waste_per_piece`]);
    }
  }, [wastePerPiece]);

  return (
    <div className='grid'>
      <div className='col-6'>
        <NumberInput
          name={`${formPath}.amount_per_piece`}
          control={control}
          label={t(
            'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.placeholders.amountPerPiece',
          )}
          minFractionDigits={0}
          maxFractionDigits={EMISSION_MAX_FRACTION_DIGIT}
          suffix=' kg'
        />
      </div>
      <div className='col-6'>
        <NumberInput
          name={`${formPath}.waste_per_piece`}
          control={control}
          label={t(
            'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.placeholders.wastePerPiece',
          )}
          minFractionDigits={0}
          maxFractionDigits={EMISSION_MAX_FRACTION_DIGIT}
          suffix=' kg'
        />
      </div>
      <div className='col-12'>
        <WasteTreatmentDropDown
          name={`${formPath}.waste_treatment`}
          label={t(
            'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.placeholders.wasteTreatment',
          )}
          processIndex={processIndex}
        />
      </div>
    </div>
  );
};

export default InputMaterialFieldsForm;
